import React, { useState, FC } from "react";
import { Button } from "reactstrap";
import { TableColumnsType } from "antd";
import { Icon, TooltipComponent } from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import { useNavigate } from "react-router";
import statusMapper from "./StatusMapperP0";
import InvoiceAside from "./InvoiceAside";
import { formatCurrency } from "../../utils/Utils";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";

const AddInvoice: FC = () => {
  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const columns: TableColumnsType<any> = [
    {
      title: "Order #",
      dataIndex: "orderId",
      key: "orderId",
      width: 250,
      fixed: "left",
      render(text: any, record: any) {
        return (
          <span
            className="inlineTableCellLink"
            onClick={() => {
              navigate(`/add-purchase-invoice/${record.orderNumber}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: " Date",
      dataIndex: "orderDate",
      key: "orderDate",
      width: 120,
      // fixed: "left",
      render: (date) => <span>{FormatDate(date)}</span>,
    },
    {
      title: "Customer",
      dataIndex: "orgName",
      key: "orgName",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`customer-tooltip-${index}`}>
              {text?.length > 20 ? `${text?.substring(0, 25)}... ` : text}
            </span>
            {text?.length > 20 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`customer-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    {
      title: "Delivery Date",
      dataIndex: "needByDate",
      key: "needByDate",
      width: 200,
      render: (date) => <span>{date ? FormatDate(date) : "N/A"}</span>,
    },
    {
      title: "Basic Amount",
      dataIndex: "basicAmount",
      key: "basicAmount",
      width: 200,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text, record.currencyCode)}</span>
        </div>
      ),
    },

    {
      title: "SGST",
      dataIndex: "sgst",
      key: "sgst",
      width: 200,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {Number(record?.sgst) && Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "CGST",
      dataIndex: "cgst",
      key: "cgst",
      width: 200,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {Number(record?.sgst) && Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "IGST",
      dataIndex: "igst",
      key: "igst",
      width: 200,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {!Number(record?.sgst) && !Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "Gross Total",
      dataIndex: "grossTotal",
      key: "grossTotal",
      width: 250,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text, record.currencyCode)}</span>
        </div>
      ),
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date) => <span>{FormatDate(date)}</span>,
      width: 100,
    },
    {
      title: "GRN Status",
      dataIndex: "deliveryStatus",
      key: "deliveryStatus",
      width: 200,
      render(value: any, record: any, index: any) {
        const grnStatus: any = {
          FullyDelivered: "Fully Delivered",
          PartiallyDelivered: "Partially Delivered",
        };
        return <p className="tb-status">{grnStatus[value] || value}</p>;
      },
    },
    {
      title: "Status",
      dataIndex: "orderStatus",
      key: "orderStatus",
      fixed: "right",
      width: 200,
      render: (status: any) => {
        const _status = statusMapper[status]?.seller;
        return (
          <div className="justify-start align-center">
            <h6
              className={`tb-status ms-1`}
              style={{
                color: `${_status?.color}`,
                fontSize: "14px",
              }}
            >
              {_status?.icon} {_status?.title || status}
            </h6>
          </div>
        );
      },
    },
  ];

  return (
    <TransactionFlowDefaultTemplate
      moduleKey="add-purchase-invoice"
      title="Purchase Orders - Invoice"
      columns={columns}
      sideNavigation={
        <div
          className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
            sm ? "content-active" : ""
          }`}
        >
          <InvoiceAside updateSm={setSm} sm={sm} />
        </div>
      }
      selectFilters={[
        {
          title: "Order Status",
          placeholder: "Select Status",
          options: [
            {
              label: "To be Invoiced",
              value: "To be Invoiced",
            },
            {
              label: "To be Dispatched",
              value: "To be Dispatched",
            },
            {
              label: "To be Delivered",
              value: "To be Delivered",
            },
            {
              label: "Partially Dispatched",
              value: "Partially Dispatched",
            },
            {
              label: "Partially Delivered",
              value: "Partially Delivered",
            },
            {
              label: "Fully Dispatched",
              value: "Fully Dispatched",
            },
            {
              label: "Fully Delivered",
              value: "Fully Delivered",
            },
          ],
        },
      ]}
      extra={{
        tableScrollX: 1100,
      }}
      topRightJSX={
        <Button
          color="primary"
          onClick={() => {
            navigate("/self-invoice");
          }}
        >
          <Icon name="plus"></Icon>
          <span>New Invoice</span>
        </Button>
      }
    />
  );
};

export default AddInvoice;
